import { FormPath } from "@/Common/Models/Forms/FormPath";
import { ElementType, FormElement, FormSection } from "@/Common/Models/Forms/FormTemplateInterfaces";
import { QuestionnaireAnswer } from "@/Common/Models/Questionnaires/QuestionnaireAnswer";
import { ElementRenderer } from "./Elements/ElementRenderer";
import { YesNoElementRenderer } from "./Elements/YesNoElementRenderer";
import { ComponentRenderer } from "./ComponentRenderer";

class SectionRenderer extends ComponentRenderer {
    private elementRenderers: ElementRenderer[];

    constructor(section: FormSection, answers: QuestionnaireAnswer[]) {
        super(section, answers);
        this.elementRenderers = section.Elements?.sortByProperty(x => x.Position).map(x => this.determineElement(x)) ?? [];
    }

    protected areAnswersOfComponent(formPath: string): boolean {
        const currentComponentFormPath = new FormPath(this.component.FormPath);
        const answerFormPath = new FormPath(formPath);
        return currentComponentFormPath.sectionNumber === answerFormPath.sectionNumber;
    }

    public isValid(): boolean {
        return !this.elementRenderers.any(x => !x.isValid());
    }

    public render(onChange?: (answer: QuestionnaireAnswer) => void, disabled: boolean = false): JSX.Element {
        return (
            <div key={this.component.InternalName}>
                {this.elementRenderers.map(element => element.render(onChange, disabled))}
            </div>
        );
    }

    private determineElement(element: FormElement): ElementRenderer {
        switch (element.ElementType) {
            case ElementType.YesNoOptionInput:
                return new YesNoElementRenderer(element, this.answers);
            default:
                throw new Error("Element isn't supported!");
        }
    }
}

export { SectionRenderer };
